/** @format */

module.exports = {
	icon: "Icon",
    iconTip:"Click to explore available icons!"
};
